// extracted by mini-css-extract-plugin
module.exports = {"mainContainer":"Main_mainContainer__sissH","innerContainer":"Main_innerContainer__1sfLC","heading":"Main_heading__22Izb","description":"Main_description__xKU1h"};